import Routes from './available_routes';

export default Routes;
